class Intercom {
  constructor(node) {
    this.node = node;
    this.id = this.node.dataset.id;
    this.baseURL = 'https://widget.intercom.io/widget/';
  }

  setLoadingState() {
    this.node.classList.add('loading');
  }

  setup() {
    window.intercomSettings = {
      api_base: 'https://api-iam.intercom.io',
      app_id: this.id,
    };
  }

  async buildScriptTag() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `${this.baseURL}${this.id}`;

    script.addEventListener('load', () => {
      document.dispatchEvent(new Event('intercom:loaded'));
    });

    document.head.appendChild(script);
  }

  /**
   * Methods from the Intercom documentation
   * More can be added
   * https://developers.intercom.com/installing-intercom/docs/intercom-javascript
   */

  // This will show the Messenger. If there are no new conversations,
  // it will open to the Messenger Home. If there are, it will open with the message list.
  showWindow() {
    window.Intercom('show');
  }

  // This will hide the main Messenger panel if it is open. It will not hide the Messenger Launcher.
  hideWindow() {
    window.Intercom('hide');
  }

  // This will open the Messenger with the message list.
  showMessages() {
    window.Intercom('showMessages');
  }

  // This will open the Messenger as if a new conversation was just created.
  // This function can also take an optional second parameter,
  // used to pre-populate the message composer as shown in the code example below..
  showNewMessage() {
    window.Intercom('showNewMessage');
  }

  // When we show the messenger, you can hook into the event. This requires a function argument.
  onHide(callback) {
    window.Intercom('onHide', callback);
  }

  // When we show the messenger, you can hook into the event. This requires a function argument.
  onShow(callback) {
    window.Intercom('onShow', callback);
  }
}

export default (node) => new Intercom(node);
